// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"36cf30d4","380":"f2e1de52","559":"ce390396","629":"b5ed6a13","637":"b6ba7a81","640":"6a8e9f1b","767":"d40f3666","873":"08e451f7","894":"2c90259a"}[chunkId] + ".chunk.css";
};